import _noop from 'lodash/noop';

import FireToast, { FireToastEventBus } from '@/views/Dashboard/components/FireToast';

export default {
  install (Vue) {
    Vue.component('FireToast', FireToast);

    let queue = Promise.resolve();
    let previousDismiss = _noop;

    // Invocation of vm.$fireToast will show toast message. First parameter is an object
    // where you can define `duration`, `immediate`, `message` and `style`.
    // `immediate` - either to show new message immediately and dismiss previous one or wait for previous message timeout.
    // `duration` - amount of time to show message.
    // `message` - string which will be displayed in toast.
    // `style` - style object.
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$fireToast = ({ duration = 5000, immediate = true, ...rest }) => {
      if (immediate) {
        previousDismiss();
      }

      let dismiss = _noop;
      queue = queue.then(() => {
        const delay = new Promise((resolve) => {
          dismiss = resolve;

          setTimeout(() => resolve(), duration);
        });

        FireToastEventBus.$emit('message', {
          ...rest,
          delay,
          dismiss,
        });

        previousDismiss = dismiss;

        return delay;
      });

      return queue;
    };
  },
};
